(function () {
  'use strict';

  function recommendedTerm(choice) {
    if (choice === 'year_sorted') return '12';
    if (choice === 'staying_least' || choice === 'spend_little') return '24';
    return '6';
  }

  function setText(el, value) {
    if (!el) return;
    el.textContent = value == null ? '' : String(value);
  }

  function initV12Logic() {
    var root = document.querySelector('.right-column-v12');
    if (!root) return;
    if (root.getAttribute('data-ml353-bound') === '1') return;
    root.setAttribute('data-ml353-bound', '1');

    if (/(?:^|[?&])v12=1(?:&|$)/.test(window.location.search || '')) {
      var v6Col = document.querySelector('.right-column-v6');
      if (v6Col) v6Col.style.setProperty('display', 'none', 'important');
      root.style.setProperty('display', 'block', 'important');
    }

    var finder = root.querySelector('.v12-plan-finder');
    var screens = root.querySelectorAll('.v12-screen');
    var cards = root.querySelectorAll('.v6-plan-card');
    var ctaBtn = document.getElementById('v12-add-to-cart');
    var toggle = document.getElementById('v12-billingToggle');
    var toggleLabel = document.getElementById('v12-toggle-label');
    var billingWrapper = root.querySelector('.billing-cards-wrapper');
    var chooseBtn = root.querySelector('.v12-choose');
    var plansAnchor = document.getElementById('v12-all-plans');
    var copyNodes = root.querySelectorAll('.v12-result-copy [data-choice]');
    var banners = root.querySelectorAll('.v12-promo-banner');
    var isDE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;

    var state = {
      step: 'intro',
      eligible: '',
      choice: '',
      history: ['intro']
    };

    function isUpfront() {
      return toggle ? toggle.checked : true;
    }

    function firstVisibleCard(term) {
      var list = root.querySelectorAll('.v6-plan-card[data-term="' + term + '"]');
      for (var i = 0; i < list.length; i++) {
        if (window.getComputedStyle(list[i]).display !== 'none') return list[i];
      }
      return list[0] || null;
    }

    function updateBanners() {
      var show = false;
      var isMobile = window.innerWidth <= 767;
      banners.forEach(function (banner) {
        var isRight = banner.classList.contains('v12-promo-banner--right');
        var visible = show && ((isMobile && isRight) || (!isMobile && !isRight));
        banner.style.setProperty('display', visible ? 'flex' : 'none', 'important');
      });
    }

    function updatePricing() {
      var upfront = isUpfront();

      if (toggleLabel) {
        toggleLabel.textContent = upfront
          ? isDE
            ? 'Vorab bezahlen'
            : 'Billed upfront'
          : isDE
            ? 'Monatlich zahlen'
            : 'Pay monthly';
      }

      cards.forEach(function (card) {
        var titleEl = card.querySelector('.dynamic-v6-title');
        var priceEl = card.querySelector('.dynamic-v6-price');
        var readerTextEl = card.querySelector('.dynamic-v6-reader-text');
        var stripTextEl = card.querySelector('.dynamic-v6-strip-text');
        var stripPriceEl = card.querySelector('.dynamic-v6-strip-price');
        var readerPriceEl = card.querySelector('.dynamic-v6-reader-price');
        var cardBadge = card.querySelector('.v6-card-badge');

        if (cardBadge) cardBadge.style.display = upfront ? 'block' : 'none';
        if (titleEl) titleEl.innerHTML = upfront ? titleEl.getAttribute('data-upfront') : titleEl.getAttribute('data-monthly');
        if (priceEl) priceEl.innerHTML = upfront ? priceEl.getAttribute('data-upfront') : priceEl.getAttribute('data-monthly');
        if (readerTextEl) {
          readerTextEl.innerHTML = upfront
            ? readerTextEl.getAttribute('data-upfront')
            : readerTextEl.getAttribute('data-monthly');
        }
        if (stripTextEl) {
          stripTextEl.innerHTML = upfront
            ? stripTextEl.getAttribute('data-upfront')
            : stripTextEl.getAttribute('data-monthly');
        }
        if (stripPriceEl) {
          stripPriceEl.innerHTML = upfront
            ? stripPriceEl.getAttribute('data-upfront')
            : stripPriceEl.getAttribute('data-monthly');
        }

        if (readerPriceEl) {
          var rPrice = upfront
            ? readerPriceEl.getAttribute('data-upfront-price')
            : readerPriceEl.getAttribute('data-monthly-price');
          var rDiscount = upfront
            ? readerPriceEl.getAttribute('data-upfront-discount')
            : readerPriceEl.getAttribute('data-monthly-discount');

          if (rDiscount && rDiscount.trim() !== '') {
            readerPriceEl.innerHTML =
              "<s style='opacity: 0.6; font-weight: normal; margin-right: 5px;'>" +
              rPrice +
              "</s> <span style='color:#F2853C; font-weight:700;'>" +
              rDiscount +
              '</span>';
          } else {
            readerPriceEl.innerHTML = rPrice || '';
          }
        }
      });

      updateBanners();

      var activeCard = root.querySelector('.v6-plan-card.is-active') || cards[0];
      if (!activeCard || !ctaBtn) return;
      var radio = activeCard.querySelector('.v6-hidden-radio');
      if (!radio) return;
      var url = upfront ? radio.getAttribute('data-url-upfront') : radio.getAttribute('data-url-monthly');
      ctaBtn.href = url || '#';
    }

    function selectCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-active');
        var radio = c.querySelector('.v6-hidden-radio');
        if (radio) radio.checked = false;
      });
      if (!card) return;
      card.classList.add('is-active');
      var radio = card.querySelector('.v6-hidden-radio');
      if (radio) radio.checked = true;
      updatePricing();
    }

    function setBillingFromQuiz(upfront) {
      if (toggle && toggle.checked !== upfront) {
        toggle.checked = upfront;
      }
      if (billingWrapper) {
        billingWrapper.querySelectorAll('.billing-card').forEach(function (card) {
          card.classList.remove('is-active');
        });
        var radio = billingWrapper.querySelector(
          'input.hidden-radio[value="' + (upfront ? 'upfront' : 'monthly') + '"]'
        );
        if (radio) {
          radio.checked = true;
          var card = radio.closest('.billing-card');
          if (card) card.classList.add('is-active');
        }
      }
      updatePricing();
    }

    function copyFor(choice) {
      for (var i = 0; i < copyNodes.length; i++) {
        if (copyNodes[i].getAttribute('data-choice') === choice) return copyNodes[i];
      }
      return null;
    }

    function fillResult() {
      var copy = copyFor(state.choice);
      if (!copy) return;
      var term = copy.getAttribute('data-term') || recommendedTerm(state.choice);
      var upfront = copy.getAttribute('data-pay') !== 'monthly';
      var card = firstVisibleCard(term) || cards[0];
      setBillingFromQuiz(upfront);
      selectCard(card);

      setText(root.querySelector('.v12-result-title'), copy.getAttribute('data-title'));
      setText(root.querySelector('.v12-result-sub'), copy.getAttribute('data-sub'));
      setText(root.querySelector('.v12-result-total-label'), copy.getAttribute('data-total-label'));
      setText(root.querySelector('.v12-result-terms'), copy.getAttribute('data-terms'));

      var upsell = root.querySelector('.v12-result-upsell');
      var upsellText = copy.getAttribute('data-upsell') || '';
      if (upsell) {
        if (upsellText) {
          setText(upsell, upsellText);
          upsell.hidden = false;
        } else {
          upsell.hidden = true;
          setText(upsell, '');
        }
      }

      if (card) {
        var priceEl = card.querySelector('.dynamic-v6-price');
        var readerTextEl = card.querySelector('.dynamic-v6-reader-text');
        var readerPriceEl = card.querySelector('.dynamic-v6-reader-price');
        var stripTextEl = card.querySelector('.dynamic-v6-strip-text');
        var stripPriceEl = card.querySelector('.dynamic-v6-strip-price');
        var radio = card.querySelector('.v6-hidden-radio');

        setText(root.querySelector('.v12-result-total-price'), priceEl ? priceEl.textContent : '');
        setText(root.querySelector('.v12-result-reader-text'), readerTextEl ? readerTextEl.textContent : '');
        var readerPriceTarget = root.querySelector('.v12-result-reader-price');
        if (readerPriceTarget) readerPriceTarget.innerHTML = readerPriceEl ? readerPriceEl.innerHTML : '';
        setText(root.querySelector('.v12-result-strip-text'), stripTextEl ? stripTextEl.textContent : '');
        setText(root.querySelector('.v12-result-strip-price'), stripPriceEl ? stripPriceEl.textContent : '');

        if (chooseBtn && radio) {
          chooseBtn.href =
            (upfront ? radio.getAttribute('data-url-upfront') : radio.getAttribute('data-url-monthly')) || '#';
        }
      }
    }

    function showResult() {
      fillResult();
      goTo('result');
    }

    function showStep(step) {
      state.step = step;
      if (finder) finder.setAttribute('data-step', step);

      screens.forEach(function (screen) {
        var match = screen.getAttribute('data-step') === step;
        screen.hidden = !match;
        screen.classList.toggle('is-active', match);
      });

      if (step !== 'q1') {
        if (finder) finder.classList.remove('is-unsure');
        var unsurePanel = root.querySelector('.v12-unsure-panel');
        var continueBtn = root.querySelector('.v12-continue');
        if (unsurePanel) unsurePanel.hidden = true;
        if (continueBtn) continueBtn.hidden = true;
      } else if (state.eligible === 'unsure') {
        showUnsure(true);
      }

      if (step === 'q2') {
        var stepScreen = root.querySelector('.v12-screen[data-step="q2"]');
        if (stepScreen) {
          stepScreen.querySelectorAll('.v12-option').forEach(function (opt) {
            opt.classList.toggle('is-selected', opt.getAttribute('data-value') === state.choice);
          });
        }
      }
    }

    function showUnsure(on) {
      if (finder) finder.classList.toggle('is-unsure', on);
      var panel = root.querySelector('.v12-unsure-panel');
      var continueBtn = root.querySelector('.v12-continue');
      if (panel) panel.hidden = !on;
      if (continueBtn) continueBtn.hidden = !on;
    }

    function goTo(step) {
      if (state.history[state.history.length - 1] !== step) {
        state.history.push(step);
      }
      showStep(step);
    }

    function startOver() {
      state.eligible = '';
      state.choice = '';
      state.history = ['intro'];
      root.querySelectorAll('.v12-option').forEach(function (opt) {
        opt.classList.remove('is-selected');
      });
      showUnsure(false);
      var defaultCard = root.querySelector('.v6-plan-card[data-default="true"]') || cards[0];
      setBillingFromQuiz(true);
      selectCard(defaultCard);
      showStep('intro');
    }

    function scrollToPlans() {
      if (!plansAnchor) return;
      plansAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    var letsGo = root.querySelector('.v12-lets-go');
    if (letsGo) {
      letsGo.addEventListener('click', function () {
        goTo('q1');
      });
    }

    var pickBelow = root.querySelector('.v12-pick-below');
    if (pickBelow) {
      pickBelow.addEventListener('click', scrollToPlans);
    }

    var q1Screen = root.querySelector('.v12-screen[data-step="q1"]');
    if (q1Screen) {
      q1Screen.querySelectorAll('.v12-option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var value = opt.getAttribute('data-value') || '';
          state.eligible = value;
          q1Screen.querySelectorAll('.v12-option').forEach(function (other) {
            other.classList.toggle('is-selected', other === opt);
          });
          if (value === 'yes') {
            showUnsure(false);
            goTo('q2');
            return;
          }
          showUnsure(true);
        });
      });
    }

    var continueBtn = root.querySelector('.v12-continue');
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        goTo('q2');
      });
    }

    var q2Screen = root.querySelector('.v12-screen[data-step="q2"]');
    if (q2Screen) {
      q2Screen.querySelectorAll('.v12-option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          state.choice = opt.getAttribute('data-value') || '';
          q2Screen.querySelectorAll('.v12-option').forEach(function (other) {
            other.classList.toggle('is-selected', other === opt);
          });
          showResult();
        });
      });
    }

    root.querySelectorAll('.v12-back').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (state.history.length < 2) return;
        state.history.pop();
        showStep(state.history[state.history.length - 1]);
      });
    });

    var seeAll = root.querySelector('.v12-see-all');
    if (seeAll) seeAll.addEventListener('click', scrollToPlans);

    var startOverBtn = root.querySelector('.v12-start-over');
    if (startOverBtn) startOverBtn.addEventListener('click', startOver);

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectCard(card);
      });
    });

    if (toggle) {
      toggle.addEventListener('change', updatePricing);
    }

    window.addEventListener('resize', updatePricing);
    window.addEventListener('pageshow', function () {
      updatePricing();
    });

    showStep('intro');
    updatePricing();
  }

  window.initV12Logic = initV12Logic;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initV12Logic);
  } else {
    initV12Logic();
  }
})();
